
import { defineComponent, computed } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "StatusBadge",
  props: {
    status: {
      type: String,
      required: true,
    },
    submitOn: {
      type: Date,
      required: false,
    },
    approveOn: {
      type: Date,
      required: false,
    },
    badgeOnly: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const severity = computed(() => {
      if (!props.status) return "danger";
      if (props.status.indexOf("เริ่มทำได้วันที่") >= 0) {
        return "info";
      } else if (props.status.indexOf("ยกเลิกแล้ว") >= 0) {
        return "danger";
      } else if (props.status.indexOf("เอกสารใหม่") >= 0) {
        return "info";
      } else if (props.status.indexOf("ส่งเอกสารให้หัวหน้างานแล้ว") >= 0) {
        return "success";
      } else if (props.status.indexOf("พนักงานกำลังแก้ไข") >= 0) {
        return "warning";
      } else if (props.status.indexOf("หัวหน้างานกำลังตรวจสอบ") >= 0) {
        return "warning";
      } else if (props.status.indexOf("หัวหน้างานอนุมัติแล้ว") >= 0) {
        return "success";
      } else if (props.status.indexOf("ใช้งานแล้ว") >= 0) {
        return "success";
      } else if (props.status.indexOf("บันทึก") >= 0) {
        return "warning";
      } else if (props.status.indexOf("ส่งเอกสารให้ HRD แล้ว") >= 0) {
        return "success";
      } else if (props.status.indexOf("สิ้นสุดการทำงาน") >= 0) {
        return "success";
      } else if (props.status.indexOf("ยังไม่ได้ใช้งาน") >= 0) {
        return "warning";
      }
      return "danger";
    });
    const { formatAppDateTime } = usePlugin();
    return {
      severity,
      formatAppDateTime,
    };
  },
});
